import React from 'react'
import Highlight from 'react-highlight'
import 'highlight.js/styles/atom-one-dark.css';

import "./Impressum.scss"

function Impressum() {
  return (
    <div className="container block is-max-desktop">
      <div className="container block">
        <h3 className="has-text-weight-bold is-size-3 honey-text-font-family-common honey-text-common">
          Impressum
        </h3>
      </div>
      <div className="column is-two-thirds honey-code">
        <Highlight className="language-markdown">
{`Firmenname:
HoneyShare GmbH

Vertreten durch:
Pedro Melgueira

Registereintrag:
Eingetragen im Handelsregister.
Registergericht: Amtsgericht Frankfurt am Main
Registernummer: HRB 140555
Adresse: Lyoner Str. 15, 60528, Frankfurt am Main, Germany
E-Mail: pedro@honeyshare.live
Umsatzsteuer-Identifikationsnummer: 014 235 70285
USt-ID-Nr.: DE458361568`}
        </Highlight>
      </div>
    </div>
  );
}

export default Impressum;
